module.exports = __webpack_public_path__ + "static/media/mascot-waiting.41f97ec9.png";